import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_GROWTH_SHARE_FOR_STARTERS_MIGRATION = createFcmConfig('growth_share_for_starters_migration', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
